export const Types = {
  FETCH_ME: "FETCH_ME",
  LOGIN: "LOGIN",
};
